import { React, useEffect } from "react";
const PopUpSevenUpdownResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;
    const dataObj = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };
    let SevenDown = "";
    let Seven = "";
    let SevenUp = "";

    let isRedWinner = "";
    let isBlackWinner = "";

    let isEvenWinner = "";
    let isOddWinner = "";
    let isClubWinner = "";
    let isDiamondWinner = "";
    let isHeartWinner = "";
    let isSpadeWinner = "";

    if (marketType == 15) {
        if (resultData?.result == 1) {
            SevenDown = "Winner";
            Seven = "LOSER";
            SevenUp = "LOSER";
        } else if (resultData?.result == 2) {
            SevenDown = "LOSER";
            Seven = "Winner";
            SevenUp = "LOSER";
        } else if (resultData?.result == 3) {
            SevenDown = "LOSER";
            Seven = "LOSER";
            SevenUp = "Winner";
        }

        let card = resultData.c1;

        if (card !== "") {
            const lastTwoChars = card.slice(-2);
            if (lastTwoChars == "CC" || lastTwoChars == "HH") {
                isRedWinner = "LOSER";
                isBlackWinner = "Winner";
            } else {
                isRedWinner = "Winner";
                isBlackWinner = "LOSER";
            }

            const firstTwoChars = card.slice(0, -2);
            let numberVal = firstTwoChars;
            if (firstTwoChars == "J") {
                numberVal = 11;
            } else if (firstTwoChars == "Q") {
                numberVal = 12;
            } else if (firstTwoChars == "K") {
                numberVal = 13;
            }
            console.log("numberVal:", numberVal);
            if (numberVal % 2 === 0) {
                isEvenWinner = "Winner";
                isOddWinner = "LOSER";
                console.log("Even Winner");
            } else {
                isEvenWinner = "LOSER";
                isOddWinner = "Winner";
                console.log("Odd Winner");
            }

            if (lastTwoChars == "CC") {
                isClubWinner = "Winner";
                isDiamondWinner = "LOSER";
                isSpadeWinner = "LOSER";
                isHeartWinner = "LOSER";
            } else if (lastTwoChars == "SS") {
                isClubWinner = "LOSER";
                isDiamondWinner = "Winner";
                isSpadeWinner = "LOSER";
                isHeartWinner = "LOSER";
            } else if (lastTwoChars == "HH") {
                isClubWinner = "LOSER";
                isDiamondWinner = "LOSER";
                isSpadeWinner = "Winner";
                isHeartWinner = "LOSER";
            } else if (lastTwoChars == "DD") {
                isClubWinner = "LOSER";
                isDiamondWinner = "LOSER";
                isSpadeWinner = "LOSER";
                isHeartWinner = "Winner";
            }
        }
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="lucky7" style={{ display: marketType == 15 ? "" : "none" }}>
                        <div class="left-content">
                            <div class="card">
                                <div class="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div class="card-body">
                                    <div className="sevenup-community-section">

                                        <div className="sevenup-community-title">
                                            Community Cards
                                        </div>

                                        <div className="sevenup-community-box">
                                            <img
                                                src={`/assets/images/cards/${resultData.c1}.svg`}
                                                className="sevenup-community-card"
                                                alt="Community Card"
                                            />
                                        </div>

                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                7Down
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{SevenDown}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                7
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{Seven}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                7Up
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{SevenUp}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Red
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isRedWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Black
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isBlackWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Odd
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isOddWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Even
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isEvenWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Club
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isClubWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Diamond
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isDiamondWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Heart
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isHeartWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Spade
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isSpadeWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <style>
                {`

        #lucky7 .card-body {
            width: 100%;
            box-sizing: border-box;
        }

        #lucky7 .sevenup-community-section {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            margin-bottom: 20px;
        }

        #lucky7 .sevenup-community-title {
            width: 100%;
            text-align: center;
            font-size: 28px;
            font-weight: 700;
            margin-bottom: 8px;
        }

        #lucky7 .sevenup-community-box {
            width: calc(100% - 40px);
            min-height: 125px;
            border: 1px solid #c8ddc8;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding: 8px;
        }

        #lucky7 .sevenup-community-card {
            display: block;
            width: 85px;
            max-width: 85px;
            height: auto;
            margin: 0 auto;
        }

        #lucky7 .market-runners {
            width: 100%;
            display: flex;
            justify-content: center;
        }

        #lucky7 .runner-runner {
            width: 100%;
            height: 55px;
            margin-top: 2px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            border-radius: 2px;
            transition: background-color .25s ease-out;
        }

        #lucky7 .runner-name {
            width: 100%;
            margin: 0;
            padding: 0;
            text-align: center;
            font-size: 30px;
            line-height: 35px;
        }

        #lucky7 .runner-info {
            width: 100%;
            text-align: center;
        }

        #lucky7 .runner-display-name {
            width: 100%;
            display: block;
            text-align: center;
        }

        #lucky7 .clippable-spacer {
            width: 100%;
            margin: 0;
            padding: 0;
            text-align: center;
        }

        #lucky7 .runner-disabled {
            width: 100%;
            line-height: 40px;
            color: #000;
            background: transparent;
            text-align: center;
            text-transform: uppercase;
            margin-top: -3px;
        }
        #lucky7 .cards {
            border: none !important;
            background: transparent !important;
            box-shadow: none !important;
            padding: 0 !important;
            margin: 0 !important;
        }

            #lucky7 .sevenup-community-box {
                width: calc(100% - 20px);
                min-height: 11px;
            }

            #lucky7 .sevenup-community-title {
                font-size: 24px;
            }

            #lucky7 .sevenup-community-card {
                width: 50px;
                max-width: 50px;
            }

            #lucky7 .runner-name {
                font-size: 26px;
            }

        
    `}
            </style>
        </div>
    );
};

export default PopUpSevenUpdownResults;

